<template>
  <div>
    <v-card elevation="0" :class="[{ 'secondary-lighten12': isMobile }]">
      <v-card-title class="text-h6"> {{ $t('Summary') }} </v-card-title>
      <v-card-text class="black--text">
        <div class="d-flex my-2 justify-space-between">
          <div class="text-subtitle-1">
            {{ item.item_name }}
          </div>
          <div>{{ toCurrency(item.amount, { currency }) }}</div>
        </div>
        <div
          v-if="itemTaxPercent && tax"
          class="d-flex text-body-1 mt-5 justify-space-between"
        >
          <div>
            {{ $t('Tax') }} ({{ itemTaxPercent }}%{{ taxInclusiveNotice }})
          </div>
          <div>{{ toCurrency(tax, { currency }) }}</div>
        </div>
        <v-divider class="my-5 secondary" />
        <div class="py-3">
          <div
            class="d-flex text-subtitle-1 font-weight-medium justify-space-between"
          >
            <div>{{ $t('Total') }}</div>
            {{ toCurrency(totalAmountIncludingTax, { currency }) }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import deviceMixin from 'components/mixins/deviceMixin'
import CommonFunctions from 'components/mixins/common-functions'
import get from 'lodash/fp/get'

export default {
  name: 'CheckoutSummary',
  mixins: [deviceMixin, CommonFunctions],
  props: ['item', 'tax', 'total', 'taxPercent', 'taxNotice', 'purchase'],
  computed: {
    totalAmount() {
      return this.item.amount.toFixed(2)
    },
    totalAmountIncludingTax() {
      return get('payment_intent.amount', this.purchase) / 100
    },
    currency() {
      return (
        this.purchase?.payment_intent?.currency ||
        this.purchase?.store_item?.currency ||
        this.purchase?.reservation?.listing?.get_currency
      )
    },
    itemTaxPercent() {
      const taxRate = this.purchase?.extra_data?.tax_rate
      if (!taxRate) {
        return this.storeTax
      }
      return (parseFloat(taxRate) * 100).toFixed(2)
    },
    taxInclusiveNotice() {
      return this.purchase?.extra_data?.is_tax_inclusive
        ? ` ${this.$t('inclusive')}`
        : ''
    },
  },
}
</script>

<style scoped>
.secondary-lighten1 {
  background-color: var(--v-secondary-lighten1);
}
.theme--light.v-divider {
  border-color: var(--v-secondary-base) !important;
}
</style>
